
<span #templateSibling></span>
<span [innerHTML]="renderedText"></span>
